import {PagesConfigActionType, PagesConfigState} from "./types";

const initialState: PagesConfigState = {
    loading: false,
    mainPageText: "",
};
const PagesConfigReducer = (state = initialState, action: any): PagesConfigState => {
    switch (action.type) {
        case PagesConfigActionType.START_REQUEST:
            return { ...state, loading: true };
        case PagesConfigActionType.MAIN_PAGE_TEXT_LOADED:
            return { ...state, loading: false, mainPageText: action.payload };
        case PagesConfigActionType.FINISH_REQUEST:
            return { ...state, loading: false };
        default:
            return state;
    }
};

export default PagesConfigReducer;
